import * as types from 'modules/notifications/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {boolean} State */

/** @type {State} */
const initialState = false;

/** @returns {State} `true` */
const startLoading = () => true;
/** @returns {State} `false` */
const endLoading = () => false;

export default createReducer(initialState, {
  [types.FETCH_CONFIGURATION]: startLoading,
  [types.PATCH_CONFIGURATION]: startLoading,
  [types.FETCH_CONFIGURATION_SUCCESS]: endLoading,
  [types.FETCH_CONFIGURATION_FAILURE]: endLoading,
  [types.PATCH_CONFIGURATION_SUCCESS]: endLoading,
  [types.PATCH_CONFIGURATION_FAILURE]: endLoading,
});
